module.exports = __webpack_public_path__ + "img/fuel_sailorstoken.7ee638a.png";